import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

export const castRtkErrorForFormik = (rtkError: FetchBaseQueryError) => {
    const errorData = rtkError.data as {[key: string]: string | string[]};
    const nonFieldErrors = "non_field_errors" in errorData ? errorData.non_field_errors : null;
    const fieldErrors = Object.keys(errorData).reduce((acc, key) => {
        if (key !== "non_field_errors") {
            return {...acc, [key]: errorData[key]};
        }
        return acc;
    }, {});

    return {
        appError: {
            status: rtkError.status,
            fieldErrors: fieldErrors,
            nonFieldErrors: nonFieldErrors || []
        }
    };
};
import {FetchBaseQueryError} from "@reduxjs/toolkit/query";

export const castRtkErrorForFormik = (rtkError: FetchBaseQueryError) => {
    const errorData = rtkError.data as {[key: string]: string | string[]};
    const nonFieldErrors = "non_field_errors" in errorData ? errorData.non_field_errors : null;
    const fieldErrors = Object.keys(errorData).reduce((acc, key) => {
        if (key !== "non_field_errors") {
            return {...acc, [key]: errorData[key]};
        }
        return acc;
    }, {});

    return {
        appError: {
            status: rtkError.status,
            fieldErrors: fieldErrors,
            nonFieldErrors: nonFieldErrors || []
        }
    };
};
